<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn fab  dark large color="brown darken-4" fixed right bottom><v-icon>person_add</v-icon></v-btn>
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>ADD NEW MOVIE</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
             <h6>   
              Note: The unique ID for this movie in this category
              will be the name of the movie which has been stripped 
              of spaces. 
             </h6>
             </v-card-text>
             <v-card-text>
                <v-form class="px-3" ref="form"> 
                     <v-text-field label="Movie Name*" v-model="name" @keypress="isName" :rules="nameRules" prepend-icon="comment"></v-text-field>
                     <v-text-field label="Category*" v-model="category" prepend-icon="money" readonly></v-text-field>
                     <v-textarea label="Description" v-model="desc" :rules="descRules" prepend-icon="edit"></v-textarea>
                     <v-text-field label="Preview Link Address*" v-model="link" prepend-icon="web" :rules="nameRules"></v-text-field>
                     
                     <v-text-field label="Duration" v-model="dura" prepend-icon="edit"></v-text-field>
                     
                     <v-icon>file_upload</v-icon> <span class="flex"><b>   Select Image File  </b> <input type="file" class="file"/></span>
                     <br/><span v-if="fileerror" class="red--text">You must select a file</span>
              
                     <span> * indicates required field </span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled">Add Movie</v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {addModuleWithAttachment} from '@/model';
import {trim} from '@/validator';
import moment from 'moment';

export default {
    name: 'AddMovie',
    props: ['category'],
    data() {
        return {
         isDisabled:false,
         desc:'',
         name:'',
         dura:'',
         link:'',
         fileerror:false,
         nameRules:[
               v => v.length >=2  || "Minimum length is 3 characters",
               v => v.length <=80  || "Maximum length is 80 characters" 
           ],
        descRules:[
               v => v.length >=15  || "Minimum length is 15 characters",
               v => v.length <=200  || "Maximum length is 200 characters" 
           ]

        };
    },
    methods: {
        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) && charcode !== 46){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        isNumber:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) || charcode == 46){
                evt.preventDefault();
            }else{
                return true;
            }
        },
        add() {
          let self=this;
            if(this.$refs.form.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            let input = document.querySelector('.file');
            
            let file = input.files[0];
            console.log(input.files);
            if(file){
                this.fileerror = false;
                
            }else{
                console.log("Choi")
                this.fileerror = true
                return;
            }
            let useradd = this.$store.getters.getStaff.name;
            let movName = this.name;
            var trimmed = trim(movName);
            let namem = trimmed+this.category;
            let newitem = {name:namem,movName:movName,link:this.link,duration:this.dura,category:this.category,desc:this.desc,file:file.type,dateadded:datenow,useradd:useradd};
          
           self.isDisabled = true;
            
              addModuleWithAttachment('movie','movies',namem.toLowerCase(),newitem,file,function(response){
                  if(response){
                      console.log("This is response: ",response);
                      alert('It has been succesfully added to your movies');
                      self.$store.dispatch('updateMovies',true);
                      self.isDisabled = false;
                  }else{
                      console.log(null);
                      self.isDisabled = false;
                  }

               })
            }
        }
    }
};
</script>

<style scoped>
</style>